@if (element.data | withLoading | async; as widget) { @if (widget.data?.data && !isEmptyObject(widget.data?.data) && !widget.loading) {
<div
    class="item indicator"
    [ngClass]="{
        'd-flex flex-direction-row justify-space-between': element.description,
        'd-flex-center justify-center flex-direction-column': !element.description
    }"
>
    <div
        id="{{ element.id }}"
        class="item-content d-flex-center flex-direction-column"
        [ngClass]="{
            'drilldown-hover-active': element?.drilldown?.show && !widget.error,
            'width-p-40': element.description,
            'p-r-30': element.description
        }"
        [routerLink]="mdrDashboardsService.buildDrilldownRouterLink(element?.drilldown?.drilldownTo, { value: widget.data?.data.value })"
        [state]="mdrDashboardsService.buildDrilldownFilters(element?.drilldown?.drilldownFilters, { value: widget.data?.data.value })"
        (mouseenter)="hideDrilldownTitle = false"
        (mouseleave)="hideDrilldownTitle = true"
    >
        <app-mdr-title
            [marginBottom]="titleMarginBottom"
            fontSize="16"
            class="item--title d-flex widget-title"
        >
            <span>
                @if (element.showCheckMarkOnEmpty && element.titleForEmpty && widget.data?.data?.value === 0) {
                <span>{{ element.titleForEmpty }} </span>
                } @if (!element.titleForEmpty && !element.showCheckMarkOnEmpty) {
                <span>{{ element.title }} </span>
                }</span
            >
            @if (element.showCheckMarkOnEmpty && widget.data?.data?.value > 0) {
            <span>{{ element.title }} </span>
            } @if (element.drilldown?.show && !widget.error) {
            <span
                [ngStyle]="{ visibility: hideDrilldownTitle ? 'hidden' : 'visible' }"
                class="drilldown-hover-active-icon"
                [ngClass]="'ds-icon-open_link fs-28'"
            ></span>
            }
        </app-mdr-title>
        <div
            [ngClass]="{
                'm-t-20': element.description,
                'justify-space-between': element.description,
                'width-p-100': element.description
            }"
            class="item-values"
        >
            @if (widget.data?.data?.value > 0 || !element.showCheckMarkOnEmpty) {
            <span class="item--value">{{
                mdrDashboardsService.intToString(
                    widget.data?.data?.value + (widget.data?.data?.value > 0 ? alterateDataWithValue : 0),
                    10000,
                    element.approximate
                )
            }}</span>
            } @if (widget.data?.data?.value === 0 && element.showCheckMarkOnEmpty) {
            <span class="item--value">
                <span class="ds-icon-validation checked-icon fs-35 item--value"> </span>
            </span>
            } @if (widget.data && widget.data.delta && !element.delta) {
            <span
                class="item--delta"
                [ngStyle]="{
                    color: widget.data.delta > 0 && element.deltaColors ? element.deltaColors?.positive : element.deltaColors?.negative
                }"
            >
                {{ element.delta ? element.delta : addDeltaSign(widget.data.delta) }}</span
            >
            } @if (element.delta) {
            <span class="item--delta"> {{ element.delta }}</span>
            }
        </div>
    </div>
    @if (element.description) {
    <div class="item-description width-p-65 delimiter p-l-30 m-t-20">
        <div
            [innerHTML]="element.description"
            class="description"
        ></div>
    </div>
    }
</div>
} @if (widget.data?.data && isEmptyObject(widget.data?.data) && !widget.loading) {
<div class="item main-item">
    <div
        class="item-content d-flex-center justify-center flex-direction-column item-content-no-value"
        id="{{ element.id }}"
    >
        <app-mdr-title
            fontSize="16"
            class="item--title d-flex widget-title"
        >
            <span>{{ element.title }}</span>
        </app-mdr-title>
        <div class="item-values">
            @if (element.showCheckMarkOnEmpty) {
            <span class="ds-icon-validation checked-icon fs-24 item--value"> </span>
            } @if (!element.showCheckMarkOnEmpty) {
            <span class="item--value">{{ defaultEmptyValue }}</span>
            } @if (widget.data && widget.data.delta && !element.showCheckMarkOnEmpty) {
            <span class="item--delta">- -</span>
            }
        </div>
    </div>
</div>
} @if (widget.error && !widget.loading) {
<div class="item main-item">
    <div
        class="item-content d-flex-center justify-center flex-direction-column item-content-no-value"
        [ngClass]="element?.drilldown && !widget.error ? 'drilldown-hover-active' : 'no-hover'"
        id="{{ element.id }}_error"
    >
        <app-mdr-title
            fontSize="16"
            class="dashboard-box-title d-flex"
            >{{ element.title }}
            @if (widget.error) {
            <span class="ds-icon-error_outline fs-25 error-primary m-l-8 line-height-08"></span>
            }
        </app-mdr-title>
        <div class="item-values">
            <span class="item--value">{{ defaultEmptyValue }}</span>
            @if (element.delta) {
            <span class="item--delta">- -</span>
            }
        </div>
    </div>
</div>
} @if (widget.loading) {
<div class="item">
    <div class="item-content d-flex-center justify-center flex-direction-column">
        <app-mdr-title
            fontSize="16"
            class="item--title d-flex widget-title"
        >
            <span>{{ element.title }}</span>
        </app-mdr-title>
    </div>
</div>
<app-mdr-loader
    [ngClass]="widget.loading ? 'widget-empty' : 'widget-loading'"
    class="center-loader width-p-40"
    [rows]="1"
    [columns]="1"
></app-mdr-loader>
} }
